import { Box, HStack, Square, Text, useColorModeValue } from '@ecoinvent/ui';

import { COLORS } from './constants';

const SupplyChainLegend = () => {
  const legendTextColor = useColorModeValue('gray.600', 'gray.400');
  const legendBg = useColorModeValue('white', COLORS.darkSurface);
  const legendBorderColor = useColorModeValue(COLORS.borderLight, COLORS.buttonOutlinedBorderDark);
  const legendShadow = useColorModeValue('sm', 'dark-lg');
  const inputColor = useColorModeValue(COLORS.greenLight, COLORS.greenDark);
  const datasetColor = useColorModeValue(COLORS.datasetBlueLight, COLORS.rootOutline);
  const consumerColor = useColorModeValue(COLORS.purpleLight, COLORS.purpleDark);

  const items = [
    { color: inputColor, label: 'Inputs' },
    { color: datasetColor, label: 'Selected dataset' },
    { color: consumerColor, label: 'Consuming activities' },
  ];

  return (
    <Box
      position="absolute"
      bottom={4}
      left={4}
      zIndex={10}
      pointerEvents="none"
      bg={legendBg}
      borderRadius="md"
      outline={`1px solid ${legendBorderColor}`}
      outlineOffset={0}
      boxShadow={legendShadow}
      py={2}
      px={3}
    >
      <HStack spacing={3}>
        {items.map(({ color, label }) => (
          <HStack key={label} spacing={1}>
            <Square size="12px" bg={color} borderRadius="sm" />
            <Text fontSize="xs" lineHeight="4" color={legendTextColor}>
              {label}
            </Text>
          </HStack>
        ))}
      </HStack>
    </Box>
  );
};

export default SupplyChainLegend;
